"use client";
import { type RefObject } from "react";
import * as stylex from "@stylexjs/stylex";
import { replayStyles as styles } from "../viewer/replay.styles";
import {
  type CoworldReplayFrameProps,
  type FrameLayout,
} from "./replay-frame.types";
import { frameSize } from "./replay-frame-layout";

export function CoworldReplayPaused({
  gate,
  onPlay,
  poster,
  ...layout
}: FrameLayout &
  Pick<CoworldReplayFrameProps, "poster"> & {
    gate: RefObject<HTMLOutputElement | null>;
    onPlay: () => void;
  }) {
  return (
    <output
      ref={gate}
      {...stylex.props(
        styles.frame,
        styles.card,
        !layout.bare && styles.bordered,
        layout.bare ? styles.page : styles.surface,
      )}
      style={frameSize(layout)}
    >
      {poster && <img src={poster} alt="" {...stylex.props(styles.poster)} />}
      <span
        {...stylex.props(styles.gate, Boolean(poster) && styles.posterGate)}
      >
        <span
          {...stylex.props(styles.text, Boolean(poster) && styles.posterText)}
        >
          Replay paused.
        </span>
        <button
          type="button"
          onClick={onPlay}
          {...stylex.props(
            styles.action,
            Boolean(poster) && styles.posterAction,
          )}
        >
          Play replay
        </button>
      </span>
    </output>
  );
}
